import { render, staticRenderFns } from "./ReporteCompras.vue?vue&type=template&id=35a13e2a&scoped=true"
import script from "./ReporteCompras.vue?vue&type=script&lang=js"
export * from "./ReporteCompras.vue?vue&type=script&lang=js"
import style0 from "./ReporteCompras.vue?vue&type=style&index=0&id=35a13e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a13e2a",
  null
  
)

export default component.exports